import { StoreState } from "store";

export const getPreFetchedFlights = (state: StoreState) => state.preFetchedFlightDetails.flights;
export const getPreFetchedFetchStatus = (state: StoreState) => state.preFetchedFlightDetails.fetchStatus;
